export const baseUrl = process.env.VUE_APP_BASE_URL_API
export const apiUrl = baseUrl
export const adminRoot = '/app'
